// The month, date and time picked in AppointmentCalendar and TimeslotGrid. Shared by
// self-serve booking and reschedule.
export const bookingTimeReducer = (state, action) => {
  switch (action.type) {
    case 'updateMonth':
      return { ...state, month: action.month, date: null, time: null };
    case 'updateDate':
      return { ...state, date: action.date, time: null };
    case 'clearSelection':
      return { ...state, date: null, time: null };
    case 'updateTime':
      return { ...state, time: action.time };
    case 'preloadData':
      return { ...state, ...action.data };
    default:
      throw new Error();
  }
};
